/* stylelint-disable a11y/media-prefers-reduced-motion */
/* stylelint-disable property-no-vendor-prefix */
/* stylelint-disable block-no-empty */
/* stylelint-disable value-no-vendor-prefix */
/* stylelint-disable declaration-block-single-line-max-declarations */

import { css, keyframes } from '@emotion/core';
/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

import StatusIcon from '../../status-icon';
import { CardTransition } from '../const';

export const Wrapper = styled.div({
  margin: `0 ${token('space.negative.250')} 0 ${token('space.500')}`,
  display: 'flex',
  minWidth: '330px',
  '@media (max-width: 600px)': {
    margin: '0 0 0 0',
    paddingRight: token('space.250'),
  },
});

export const Loading = styled.div({
  position: 'relative',
  width: '100%',
  padding: `${token('space.300')} 0`,
  textAlign: 'center',
});

export const Dashboard = styled.div<{ state: string }>(({ state }) => ({
  width: '100%',
  flexDirection: 'column',
  marginTop: token('space.500'),
  paddingRight: '60px',
  transition: 'width 250ms ease-in-out',
  ...(state === 'entering' && { width: '100%' }),
  ...(state === 'entered' && { width: 'calc(100% - 440px)' }),
  '@media (max-width: 600px)': {
    paddingRight: '0',
    ...(state === 'entering' && { width: '100%' }),
    ...(state === 'entered' && { width: '100%', display: 'none' }),
  },
  '@media (min-width: 1400px)': {
    ...(state === 'entering' && { width: '100%' }),
    ...(state === 'entered' && { width: 'calc(100% - 600px)' }),
  },
}));

export const History = styled.div<{ state: string }>(({ state }) => ({
  marginTop: '-94px',
  marginBottom: token('space.negative.250'),
  transition: 'transform 250ms ease-in-out',
  transform: 'translateX(0)',
  height: '100vh',
  minHeight: '100vh',
  backgroundColor: token('color.background.input'),
  position: 'fixed',
  right: 0,
  width: '400px',
  marginRight: '-400px',
  ...(state === 'entering' && { transform: 'translateX(0)' }),
  ...(state === 'entered' && { transform: 'translateX(-400px)' }),
  '@media (max-width: 600px)': {
    width: '100%',
    margin: 0,
    position: 'absolute',
    zIndex: 1,
    top: 0,
    left: 0,
    display: 'none',
    ...(state === 'entering' && {
      display: 'none',
      transform: 'translateX(0)',
    }),
    ...(state === 'entered' && {
      display: 'block',
      transform: 'translateX(0)',
    }),
  },
  '@media (min-width: 1400px)': {
    width: '600px',
    marginRight: '-600px',
    ...(state === 'entering' && { transform: 'translateX(0)' }),
    ...(state === 'entered' && { transform: 'translateX(-600px)' }),
  },
}));

export const SettingsButton = styled.div({
  float: 'right',
  marginTop: '-70px',
  marginRight: token('space.200'),
});

export const HistoryWrapper = styled.div({
  boxSizing: 'border-box',
  overflow: 'hidden',
  height: '100%',
});

export const HistoryHeader = styled.div`
  display: flex;
  align-items: center;
  flex-direction: space-between;
  box-sizing: border-box;
  padding: ${token('space.100')} ${token('space.100')} ${token('space.100')}
    ${token('space.200')};
  margin: ${token('space.negative.100')} 0 ${token('space.100')};
`;

export const EnvironmentName = styled.div({
  boxSizing: 'border-box',
  color: token('color.text'),
  font: token('font.heading.medium'),
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  borderRadius: '3px',
  paddingTop: token('space.250'),
});

export const HistoryTitle = styled.div({
  boxSizing: 'border-box',
  padding: `${token('space.100')} ${token('space.200')}`,
  font: token('font.body.large'),
  fontWeight: token('font.weight.medium'),
  borderRadius: '3px',
  marginBottom: token('space.100'),
});
export const HistoryList = styled.div({
  overflowY: 'auto',
  overflowX: 'hidden',
  scrollBehavior: 'smooth',
  height: 'calc(100vh - 130px)',
  padding: `${token('space.025')} ${token('space.025')} 15px`,
  '> div': {
    height: 'auto',
    position: 'relative',
  },
});

export const HistoryLoading = styled.div({
  position: 'relative',
  width: '100%',
  padding: `${token('space.300')} 0`,
  textAlign: 'center',
});

export const HistoryCloseButton = styled.div({
  marginLeft: 'auto',
});

export const HistoryShowMoreButton = styled.div({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: token('space.200'),
});

const slideUp = keyframes({
  '0%': {
    transform: 'translateY(105px)',
  },
  '80%': {
    transform: 'translateY(-15px)',
  },
  '100%': {
    transform: 'translateY(0)',
  },
});

const slideDown = keyframes({
  '0%': {
    transform: 'translateY(0)',
    pointerEvents: 'none',
  },
  '20%': {
    transform: 'translateY(-15px)',
    pointerEvents: 'none',
  },
  '100%': {
    transform: 'translateY(105px)',
    pointerEvents: 'none',
  },
});

const slideOut = keyframes({
  '0%': {
    transform: 'translateY(0)',
  },
  '20%': {
    transform: 'translateY(15px)',
  },
  '100%': {
    transform: 'translateY(-42px)',
    height: 'calc(100% - 16px)',
  },
});

const fadeIn = keyframes({
  from: {
    opacity: 0,
  },
  to: {
    opacity: 1,
  },
});

export const CardWrapper = styled.div<{
  isOverlayCard: boolean;
  transition: CardTransition;
}>`
  margin: ${token('space.100')};
  background-color: ${token('elevation.surface.raised')};
  border-radius: 3px;
  box-sizing: border-box;
  padding: ${token('space.100')};
  min-height: 120px;
  transition: 0.3s;
  transform: translate3d(0, 0, 0);
  position: absolute;
  width: calc(100% - 16px);
  overflow: hidden;

  ${({ isOverlayCard, transition }) =>
    isOverlayCard && transition !== CardTransition.SwapCards
      ? `box-shadow: 0 -2px 8px -2px rgba(9,30,66,0.25), 0 0 1px rgba(9,30,66,0.31);`
      : `box-shadow: ${token('elevation.shadow.raised')}}`};
  ${({ isOverlayCard }) =>
    isOverlayCard
      ? `height: calc(100% - 58px); min-height: 50px; top: 42px`
      : `top: 0; height: calc(100% - 16px);`};
  ${({
    isOverlayCard,
    transition,
  }: {
    isOverlayCard: boolean;
    transition: string;
  }) =>
    isOverlayCard &&
    (
      {
        [CardTransition.None]: css({
          animation: `${slideUp} 500ms ease-in-out 1 forwards`,
        }),
        [CardTransition.ShowOverlayCard]: css({
          animation: `${slideUp} 500ms ease-in-out 1 forwards`,
        }),
        [CardTransition.HideOverlayCard]: css({
          animation: `${slideDown} 500ms ease-in-out 1 forwards`,
        }),
        [CardTransition.SwapCards]: css({
          animation: `${slideOut} 500ms ease-in-out 1 forwards`,
        }),
      } as any
    )[transition]};

  &:focus,
  &:hover {
    background-color: ${token('elevation.surface.raised.hovered')};
    cursor: pointer;
  }
`;

export const Status = styled.div({
  display: 'flex',
  textIndent: 0,
  padding: `3px ${token('space.050')} 3px 3px`,
  svg: {
    margin: 0,
    width: '18px',
    height: '18px',
  },
});
export const BuildNumber = styled.h5({
  position: 'absolute',
  font: token('font.heading.small'),
  top: token('space.100'),
  display: 'flex',
  alignItems: 'center',
  textIndent: '4px',
  cursor: 'pointer',
});
export const PipelineLink = styled.a({
  '&:focus, &:hover': {
    color: token('color.text'),
  },
});
export const DisabledPipeline = styled.span({
  color: token('color.text.disabled'),
});

export const CommitMessage = styled.div<{
  shouldTransition: boolean;
  clamp: number;
}>`
  margin-top: ${token('space.400')};
  word-break: break-word !important;

  ${({ shouldTransition }: { shouldTransition: boolean; clamp: number }) =>
    shouldTransition &&
    css({
      animation: `${fadeIn} 500ms ease-in-out 1 forwards`,
    })};

  max-height: ${({ clamp }) => `${clamp * 20}px`};
  overflow: hidden;
  text-overflow: ellipsis;

  @supports (-webkit-line-clamp: 3) {
    -webkit-box-orient: vertical;
    display: -webkit-box;
    -webkit-line-clamp: ${({ clamp }) => clamp};
  }

  span {
    display: inline-block;
  }
`;

export const StyledDeploymentDate = styled.div({
  position: 'absolute',
  bottom: token('space.100'),
});
export const DeployerAvatar = styled.div({
  position: 'absolute',
  bottom: token('space.100'),
  right: token('space.100'),
  width: '28px',
  height: '28px',
});

export const CardActionsWrapper = styled.div({
  position: 'absolute',
  top: token('space.050'),
  right: token('space.050'),
});

export const CommitLink = styled.span({
  fontWeight: token('font.weight.semibold'),
  fontFamily: token('font.family.code'),
  minWidth: '64px',
  color: token('color.text'),
});
export const ItemWrapper = styled.div({
  marginBottom: '18px',
});
const getStateColor = (color: string, hoverColor: string) => ({
  background: color,
  '&:hover': {
    background: hoverColor,
    '& > span': {
      display: 'inline-block',
    },
  },
});
export const EnvironmentHeaderWrapper = styled.div<{ isSelected: boolean }>(
  ({ isSelected }) => ({
    ...(isSelected && {
      boxSizing: 'border-box',
      border: `3px solid ${token('color.border.focused')}`,
      borderRadius: '7px',
      margin: '-3px',
    }),
  })
);
export const EnvironmentHeaderEmptyState = styled.div({});

export const EnvironmentHeaderTitle = styled.div<{
  state?: any;
  isSelected?: boolean;
}>`
  display: flex;
  position: relative;
  align-items: center;
  height: 58px;
  background: ${token('elevation.surface.sunken')};
  width: 100%;
  border-radius: 3px 3px 0 0;
  box-sizing: border-box;
  padding: 15px 17px;
  transition: 0.3s;
  cursor: ${({ state }: { state?: any; isSelected?: boolean }) =>
    state ? 'pointer' : 'default'};
  color: ${({ state, isSelected }) =>
    state
      ? isSelected
        ? token('color.text')
        : token('color.text.inverse')
      : token('color.text.disabled')};
  ${({ state, isSelected }) =>
    !isSelected &&
    state === 'success' &&
    getStateColor(
      token('color.icon.success'),
      token('color.background.success.bold.hovered')
    )};
  ${({ state, isSelected }) =>
    !isSelected &&
    state === 'paused' &&
    getStateColor(
      token('color.icon.success'),
      token('color.background.success.bold.hovered')
    )};
  ${({ state, isSelected }) =>
    !isSelected &&
    state === 'rerun' &&
    getStateColor(
      token('color.icon.success'),
      token('color.background.success.bold.hovered')
    )};
  ${({ state, isSelected }) =>
    !isSelected &&
    state === 'redeploy' &&
    getStateColor(
      token('color.icon.success'),
      token('color.background.success.bold.hovered')
    )};
  ${({ state, isSelected }) =>
    !isSelected &&
    state === 'building' &&
    getStateColor(
      token('color.background.information.bold'),
      token('color.background.information.bold.hovered')
    )};
  ${({ state, isSelected }) =>
    !isSelected &&
    state === 'stopped' &&
    getStateColor(token('color.icon.subtle'), token('color.text.subtle'))};
  ${({ state, isSelected }) =>
    !isSelected &&
    state === 'failed' &&
    getStateColor(
      token('color.icon.danger'),
      token('color.background.danger.bold.hovered')
    )};
  ${({ state, isSelected }) =>
    !isSelected &&
    state === 'failedRedeploy' &&
    getStateColor(
      token('color.icon.danger'),
      token('color.background.danger.bold.hovered')
    )};
  ${({ isSelected }) =>
    isSelected &&
    getStateColor(
      token('color.background.selected'),
      token('color.background.selected.hovered')
    )};
  ${({ state }) =>
    !state &&
    `
			padding-left: 49px;
			&:after {
				content: '';
				display: block;
				width: 18px;
				height: 18px
				border: 3px solid ${token('color.border')};
				border-radius: 20px;
				position: absolute;
				left: 16px;
			}`};
`;

export const EnvrionmentHeaderStatus = styled(StatusIcon as any)({
  height: '24px',
  width: '24px',
  marginRight: token('space.100'),
  color: 'inherit !important',
  svg: {
    width: '24px',
    height: '24px',
    margin: 0,
  },
  "&[data-state='icon-pending'] span": {
    width: '24px',
    height: '24px',
    color: token('color.text.information'),
    background: token('elevation.surface'),
    borderRadius: '12px',
    '&::after': {
      height: '96px',
      font: token('font.body.large'),
      top: token('space.050'),
      marginLeft: '3px',
    },
  },
} as any);

export const EnvironmentHeaderName = styled.h4({
  margin: 0,
  font: token('font.heading.medium'),
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  color: 'inherit',
});
export const EnvironmentHeaderIcon = styled.span({
  flex: '1 0 auto',
  textAlign: 'right',
  opacity: 0.5,
  marginRight: token('space.negative.075'),
  display: 'none',
});

const fadeOut = keyframes({
  from: {
    opacity: 1,
  },
  to: {
    opacity: 0.5,
    transform: 'scale(0.97)',
  },
});

export const EnvironmentHeaderCardWrapper = styled.div<{
  transition?: CardTransition;
  isSelected?: boolean;
}>(({ transition, isSelected }) => ({
  height: '160px',
  width: '100%',
  background: token('elevation.surface.sunken'),
  borderRadius: '0 0 5px 5px',
  boxSizing: 'border-box',
  transition: '0.3s',
  position: 'relative',
  display: 'flex',
  overflow: transition === CardTransition.SwapCards ? 'visible' : 'hidden',
  '& > div:first-of-type': {
    ...(transition === CardTransition.SwapCards && {
      animation: `${fadeOut} 500ms ease-in-out 1 forwards`,
    }),
  },
  ...(isSelected && {
    background: token('color.background.selected'),
  }),
}));

export const EnvironmentHeaderEmptyMessage = styled.h5({
  color: token('color.text'),
  font: token('font.body.small'),
  alignSelf: 'center',
  textAlign: 'center',
  width: '100%',
  userSelect: 'none',
});

export const ButtonWrapper = styled.div({
  position: 'absolute',
  top: token('space.100'),
  right: token('space.100'),
  display: 'block',
});

export const subtleSelector = (
  cssToApply: { backgroundColor: string; borderColor: string },
  state: { isFocused: boolean }
): {
  backgroundColor: string;
  borderColor: string;
} => ({
  backgroundColor: state.isFocused ? cssToApply.backgroundColor : 'transparent',
  borderColor: state.isFocused ? cssToApply.borderColor : 'transparent',
});
